import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import kebabCase from 'lodash/kebabCase.js';
import icons from './icons.js';
import { warn } from '../../utils/console.js';
import { iconTypeToGeneric } from '../../utils/utils.js';

var script = {
  name: 'PendoIcon',
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      required: true
    },
    fill: {
      type: String,
      default: 'none'
    },
    size: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: null
    },
    width: {
      type: [Number, String],
      default: null
    },
    stroke: {
      type: String,
      default: 'currentColor'
    },
    strokeLinecap: {
      type: String,
      default: 'round'
    },
    strokeLinejoin: {
      type: String,
      default: 'round'
    },
    strokeWidth: {
      type: [Number, String],
      default: 2
    },
    tag: {
      type: String,
      default: 'i'
    },
    display: {
      type: String,
      default: 'block'
    }
  },
  computed: {
    icon() {
      const typeLookup = {
        account: 'users',
        feature: 'feature',
        guide: 'guide',
        page: 'file',
        parentAccount: 'home',
        poll: 'list',
        trackType: 'zap',
        visitor: 'user',
        web: 'monitor'
      };
      const type = kebabCase(typeLookup[this.type] || this.type);
      return icons[type];
    },
    defaultAriaLabel() {
      return iconTypeToGeneric(this.type);
    }
  },
  render(createElement) {
    const {
      $listeners,
      $attrs,
      defaultAriaLabel,
      display,
      fill,
      height,
      icon,
      size,
      stroke,
      strokeLinecap,
      strokeLinejoin,
      strokeWidth,
      tag,
      type,
      width
    } = this;
    if (!icon) {
      return warn(`[PendoIcon]: can't find matching icon for '${type}'.`);
    }
    return createElement(tag, {
      class: {
        'pendo-icon': true,
        [`pendo-icon__${type}`]: type
      },
      on: $listeners
    }, [createElement('svg', {
      attrs: _objectSpread2(_objectSpread2(_objectSpread2({}, icon.attrs), {}, {
        'aria-label': defaultAriaLabel
      }, $attrs), {}, {
        fill,
        stroke,
        display,
        'height': height || size,
        'width': width || size,
        'stroke-linecap': strokeLinecap,
        'stroke-linejoin': strokeLinejoin,
        'stroke-width': strokeWidth
      }),
      class: [icon.attrs.class, 'pendo-icon__content'],
      domProps: {
        innerHTML: icon.contents
      }
    })]);
  }
};

export { script as default };
//# sourceMappingURL=pendo-icon.vue2.js.map
